import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';

@Injectable()
export class RgpdProvider {

    constructor(public http: HttpClient, private commonService: CommonProvider) { }

    private _url: string = `${this.commonService.apiUrl}api/v1/rgpd`;

    deleteDatasFromApp(): Observable<Response<any>> {
        return this.http.get<Response<any>>(this._url + '/deleteDatasFromApp');
    }

    downloadRgpdReport(): Observable<Response<any>> {
        return this.http.get<Response<any>>(this._url + '/downloadRgpdReport');
    }

}




// WEBPACK FOOTER //
// ./src/providers/rgpd/rgpd.ts